export const MISSION_STATUS = {
  SOLICITADO: "Solicitado",
  AGENDADO: "Agendado",
  AUTORIZADO: "Autorizado",
  CONFIRMADO: "Confirmado",
  EM_ANDAMENTO: "Em andamento",
  FINALIZADO: "Finalizado",
  CANCELADO: "Cancelado",
};

export const StatusToConfirm = [
  MISSION_STATUS.AUTORIZADO,
  MISSION_STATUS.CONFIRMADO,
];

export const MissionStatusNotAuthorizedAdmin = [
  MISSION_STATUS.SOLICITADO,
  MISSION_STATUS.AGENDADO,
  MISSION_STATUS.AUTORIZADO,
];

export const MissionStatusNotAuthorized = [
  MISSION_STATUS.SOLICITADO,
  MISSION_STATUS.AGENDADO,
];

export const MissionStatusAuthorized = [
  MISSION_STATUS.EM_ANDAMENTO,
  MISSION_STATUS.FINALIZADO,
  MISSION_STATUS.CANCELADO,
];

export const StageFinishedStatus = [
  MISSION_STATUS.FINALIZADO,
  MISSION_STATUS.CANCELADO,
];

export const StageNotFinishedStatus = [
  MISSION_STATUS.SOLICITADO,
  MISSION_STATUS.AGENDADO,
  MISSION_STATUS.AUTORIZADO,
  MISSION_STATUS.CONFIRMADO,
  MISSION_STATUS.EM_ANDAMENTO,
];

export const MissionStatusOption = [
  MISSION_STATUS.SOLICITADO,
  MISSION_STATUS.AGENDADO,
  MISSION_STATUS.AUTORIZADO,
  MISSION_STATUS.CONFIRMADO,
  MISSION_STATUS.EM_ANDAMENTO,
  MISSION_STATUS.FINALIZADO,
  MISSION_STATUS.CANCELADO,
];

export const MissionStatusGeral = [
  MISSION_STATUS.EM_ANDAMENTO,
  MISSION_STATUS.FINALIZADO,
  MISSION_STATUS.CANCELADO,
];

export const MissionStatusGeneral = [
  MISSION_STATUS.SOLICITADO,
  MISSION_STATUS.AGENDADO,
  MISSION_STATUS.EM_ANDAMENTO,
  MISSION_STATUS.AUTORIZADO,
  MISSION_STATUS.CONFIRMADO,
  MISSION_STATUS.FINALIZADO,
  MISSION_STATUS.CANCELADO,
];

export const MissionStatusOptionToChange = [
  MISSION_STATUS.SOLICITADO,
  MISSION_STATUS.AGENDADO,
  MISSION_STATUS.CONFIRMADO,
  MISSION_STATUS.EM_ANDAMENTO,
  MISSION_STATUS.FINALIZADO,
  MISSION_STATUS.CANCELADO,
];

export const PROFILE_STATUS = {
  ADMINISTRACAO: "Administração",
  COORDENACAO: "Coordenação",
  MANUTECAO: "Manutenção",
  OPERACOES: "Operações",
  SOLICITANTE: "Solicitante",
  PASSAGEIRO: "Passageiro",
};

export const ProfileOption = [
  PROFILE_STATUS.ADMINISTRACAO,
  PROFILE_STATUS.COORDENACAO,
  PROFILE_STATUS.MANUTECAO,
  PROFILE_STATUS.OPERACOES,
  PROFILE_STATUS.SOLICITANTE,
];

export const ProfileOptionPassaenger = [
  PROFILE_STATUS.ADMINISTRACAO,
  PROFILE_STATUS.COORDENACAO,
  PROFILE_STATUS.MANUTECAO,
  PROFILE_STATUS.OPERACOES,
  PROFILE_STATUS.SOLICITANTE,
  PROFILE_STATUS.PASSAGEIRO,
];

export const denyEditProfiles = [
  PROFILE_STATUS.MANUTECAO,
  PROFILE_STATUS.SOLICITANTE,
  PROFILE_STATUS.PASSAGEIRO,
];

export const allowAccessToMissionRequestAdmin = [
  PROFILE_STATUS.ADMINISTRACAO,
  PROFILE_STATUS.MANUTECAO,
  PROFILE_STATUS.OPERACOES,
  PROFILE_STATUS.COORDENACAO,
];

export const allowAccessMenu = [
  PROFILE_STATUS.ADMINISTRACAO,
  PROFILE_STATUS.MANUTECAO,
  PROFILE_STATUS.OPERACOES,
  PROFILE_STATUS.COORDENACAO,
];

export const allowAccessComplete = [
  PROFILE_STATUS.ADMINISTRACAO,
  PROFILE_STATUS.MANUTECAO,
  PROFILE_STATUS.OPERACOES,
];

export const allowAutorizar = [PROFILE_STATUS.ADMINISTRACAO];

export const closedStatus = [
  MISSION_STATUS.FINALIZADO,
  MISSION_STATUS.CANCELADO,
];

export const getStatus = (status) => {
  if (status === MISSION_STATUS.AUTORIZADO) {
    return "Autorização 1";
  }
  if (status === MISSION_STATUS.CONFIRMADO) {
    return "Autorização 2";
  }
  return status;
};

export const isVooLiberado = (status) => {
  if (MissionStatusNotAuthorized.includes(status)) {
    return "Nenhuma autorização";
  }
  if (status === MISSION_STATUS.AUTORIZADO) {
    return "Apenas uma autorização, é necessário mais uma.";
  }
  if (status === MISSION_STATUS.CONFIRMADO) {
    return "Realizado as duas autorizações, etapa liberada, clique em alterar status para colocar Em Andamento.";
  }
  if (status === MISSION_STATUS.EM_ANDAMENTO) {
    return "Etapa em andamento";
  }
  if (status === MISSION_STATUS.FINALIZADO) {
    return "Etapa finalizada.";
  }
  if (status === MISSION_STATUS.CANCELADO) {
    return "Etapa cancelada.";
  }
  return "";
};



// WEBPACK FOOTER //
// ./src/enums.js